import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import './team.css';

function TeamForm() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [form, setForm] = useState({
    name: '',
    description: '',
    memberEmails: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    if (!id) return;

    const loadTeam = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/teams/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setForm({
          name: res.data.name,
          description: res.data.description || '',
          memberEmails: res.data.members.map((m) => m.email).join(', '),
        });
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to load team');
      } finally {
        setLoading(false);
      }
    };

    loadTeam();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const token = localStorage.getItem('token');
      const payload = {
        name: form.name,
        description: form.description,
        memberEmails: form.memberEmails.split(',').map((email) => email.trim()).filter(Boolean),
      };

      if (id) {
        await axios.put(`${process.env.REACT_APP_API_URL}/teams/${id}`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setSuccess('Team updated successfully');
      } else {
        await axios.post(`${process.env.REACT_APP_API_URL}/teams`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setSuccess('Team created successfully');
      }

      setTimeout(() => navigate('/teams'), 800);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to save team');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="team-page">
      <h2>{id ? 'Edit Team' : 'Create Team'}</h2>
      <form className="team-form" onSubmit={handleSubmit}>
        {error && <div className="error-message">{error}</div>}
        {success && <div className="success-message">{success}</div>}

        <label>
          Team Name
          <input name="name" value={form.name} onChange={handleChange} required />
        </label>

        <label>
          Description
          <textarea name="description" value={form.description} onChange={handleChange} rows="4" />
        </label>

        <label>
          Member Emails (comma separated)
          <textarea
            name="memberEmails"
            value={form.memberEmails}
            onChange={handleChange}
            rows="3"
            placeholder="user1@example.com, user2@example.com"
          />
        </label>

        <button className="button primary-button" type="submit" disabled={loading}>
          {loading ? 'Saving...' : id ? 'Save Team' : 'Create Team'}
        </button>
      </form>
    </div>
  );
}

export default TeamForm;
